import { QueryResult, useQuery } from '@apollo/client'
import {
  Country,
  GetAppraisalsWithFeedbackByCountryAndFiltersQuery,
  GetAppraisalsWithFeedbackByCountryAndFiltersQueryVariables,
  HrSupportFeedbackTabFilter,
  CursorPaginationMeetingInput,
} from '../../../types'
import { APPRAISALS_WITH_FEEDBACK_BY_COUNTRY_AND_FILTERS } from '../MeetingQueries'

export const useAppraisalsWithFeedbackByCountryAndFilters = (
  country: Country,
  filters: HrSupportFeedbackTabFilter,
  pagination: CursorPaginationMeetingInput,
): QueryResult<GetAppraisalsWithFeedbackByCountryAndFiltersQuery, GetAppraisalsWithFeedbackByCountryAndFiltersQueryVariables> => {
  return useQuery<GetAppraisalsWithFeedbackByCountryAndFiltersQuery, GetAppraisalsWithFeedbackByCountryAndFiltersQueryVariables>(
    APPRAISALS_WITH_FEEDBACK_BY_COUNTRY_AND_FILTERS,
    {
      variables: {
        country,
        filters,
        pagination,
      },
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true,
    },
  )
}
